import { API, BACKEND_HOST } from "../api";
import { useEffect, useState } from "react";


const UsageSection = ({ productType }) => {
    const [usage, setUsage] = useState(null);

    const [show, setShow] = useState(false);

    const fetchData = () => {
        let url = ""
        console.log("UsageSection", productType)
        if (productType === "coupon") {
            url = `/coupon/coupon-usage/`
        } else if (productType === "voucher") {
            url = `/voucher/voucher-usage/`
        } else if (productType === "precoupon") {
            url = `/precoupon/coupon-usage/`
        }

        API.get(
            `${BACKEND_HOST}${url}`
        )
            .then((res) => {
                setUsage(res.data)
            })
    }

    useEffect(() => {
        fetchData();
    }, [])

    if (!usage) {
        return <div>Loading...</div>
    }

    return (
        <div className="d-flex flex-column gap-1 mb-2">
            <div className="d-flex flex-row gap-2 align-items-center">
                <div>생성: {usage.total_count}</div>
                <div>사용: {usage.used_count}</div>
                <div>미사용: {usage.unused_count}</div>
                {show ? <div>
                    <div className="btn btn-info"
                        onClick={() => setShow(false)}>사용량 현황 상세 닫기</div>
                </div> : <div>
                    <div className="btn btn-info"
                        onClick={() => setShow(true)}>사용량 현황 상세 보기</div>
                </div>}
            </div>

            {show && <div>
                {usage?.coupon_by_product?.map((item, index) => {
                    return (
                        <div key={index} className="d-flex flex-row gap-2">
                            {/* <div>product_id: {item.id}</div> */}
                            <div style={{ width: "140px", overflow: "clip" }}>{item.name}</div>
                            <div style={{ width: "60px" }}>total: {item.total_count}</div>
                            <div style={{ width: "60px" }}>사용: {item.used_count}</div>
                            <div style={{ width: "60px" }}>미사용: {item.unused_count}</div>
                        </div>
                    )
                })}
                {usage?.voucher_by_product?.map((item, index) => {
                    return (
                        <div key={index} className="d-flex flex-row gap-2">
                            {/* <div>product_id: {item.id}</div> */}
                            <div style={{ width: "140px", overflow: "clip" }}>{item.name}</div>
                            <div style={{ width: "60px" }}>total: {item.total_count}</div>
                            <div style={{ width: "60px" }}>사용: {item.used_count}</div>
                            <div style={{ width: "60px" }}>미사용: {item.unused_count}</div>
                        </div>
                    )
                })}
            </div>}

        </div>
    )
}

export default UsageSection;